import useGetSettingsNotificationListItems from './useGetSettingsNotificationListItems'
export default useGetSettingsNotificationListItems
